// extracted by mini-css-extract-plugin
export var footer = "_qg-5";
export var fulfillmentInput = "_qg-0";
export var shipDateInput = "_qg-1";
export var shipmentModal = "_qg-2";
export var shipmentModalContent = "_qg-3";
export var tableContainer = "_qg-4";